// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xg_a bhj_vn bhj_vf bhj_xb bhj_re bhj_tp bhj_qv"};